(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["customer-reviews"]) return;
  try {
    
   const swiper = new Swiper('.customer-reviews__slider', {
      // Optional parameters
      loop: true,
      slidesPerView: 1,
       effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
      navigation: {
        nextEl: '.slider-nav .next',
        prevEl: '.slider-nav .prev',
      },
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  $(window).on("load", function(){
    setTimeout(function(){
       const element = document.querySelector(".jdgm-row-actions .jdgm-sort-dropdown-wrapper .jdgm-sort-dropdown");
        if(element){
           const choices = new Choices(element, {
              searchEnabled: false,
              itemSelectText: '',
            });
        }
      console.log(element);
    }, 0)




    
  }); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !window.DesignMode) return;
  try {
    
 $(document).ready(function(){

   $(".success-popup .close").on("click", function(e){
     e.preventDefault();
     $(".success-popup__wrapper").hide(200);
   })
    var form2 = $('.newsletter-section form');
   
    
   $(".newsletter-section form").submit(function(e){
    
        e.preventDefault();
        
        if($(this).find('[type="email"]').val() === ""){
          $(".newsletter-section form .errors").removeClass("hide");
        }else{
           $(".newsletter-section form .errors").addClass("hide");
           $.ajax({
              type: "POST",
              url: form2.attr('action'),
              cache: false,
              data: $(this).serialize(),
               success: function(data){
                   console.log("success");
                  $(".success-popup__wrapper").show(200);
              },
          })
        }
       
      
        
    });

   console.log("ajax")
    
}); 

  } catch(e) { console.error(e); }
})();

})();
